import "./AboutUsStyles.css";

function AboutUs() {
  return (
    <div className="about-container">
      <h1>Our History</h1>
      <p>
        Swat is a stunning valley and a famous tourist destination located in
        the upper north region of the Khyber Pakhtunkhwa Province of Pakistan.
        Swat district is situated at a distance of 247 Km (153 Miles) from the
        capital city of Islamabad at an approximate travel time of a little over
        3 hours via the M1 and M16 Swat Motorway.
      </p>

      <h1>What People Thinks</h1>
      <p>
        Swat is best known as the Switzerland of the east and is commonly known
        as “Paradise on the Earth” for its spectacular natural beauty spread
        across its area of 5,337 km2 (2,061 sq. mi.). The upper Swat is
        specifically famous for its breathtaking natural beauty and diverse
        wildlife. Swat is renowned for its lush green scenic landscapes, alpine
        snow-peaked mountains, clear water springs & streams, and picturesque
        meadows. In addition, the pollution-free atmosphere, inviting weather,
        charming & hospitable people, winter sports activities, and its
        well-known ski resort are also among the prominent captivating features
        of Swat. Until 1969 Swat remained an affluent and independent sovereign
        state known as “The Yusafzai State of Swat”. During the British empire’s
        invasion and rule of the Indian subcontinent between 1858 and 1947, Swat
        remained free and independent. The proud local Yusafzai Pashtuns kept
        Swat in their total control. The State of Swat willingly merged with
        Pakistan on 14 October 1969. This unification occurred after 22 years
        when Pakistan eventually achieved independence from British rule in
        1947.
      </p>
    </div>
  );
}

export default AboutUs;
